import { useTranslation } from 'react-i18next';

import { NgNotificationBadge } from '@/ui';
import type { IncidentListRow } from '@ngsos/portal-core/incidents';

export type IncidentPurposeBadgeProps = {
  purpose: IncidentListRow['purpose'];
};

export function IncidentPurposeBadge({ purpose }: IncidentPurposeBadgeProps) {
  const { t } = useTranslation();

  if (purpose !== 'Test') {
    return null;
  }

  return (
    <NgNotificationBadge
      color="red"
      text={t('Incident_Purpose_Test_Badge')}
      textColorClass="text-uppercase"
      additionalClasses="incident-purpose-test-badge"
    />
  );
}
